import React from 'react';
import '../styles/UserProfile.css';

const UserProfile = ({ user }) => {
    if (!user) return null;

    // ✅ 커플 상태 확인 방식 변경
    const isInCouple = user.coupleId !== null && user.coupleId !== undefined;
    
    const getCoupleStatusText = () => {
        return isInCouple ? '커플' : '싱글';
    };

    const getCoupleStatusColor = () => {
        return isInCouple ? '#28a745' : '#6c757d';
    };

    return (
        <div className="user-profile">
            <div className="profile-header">
                <div className="profile-avatar">
                    {user.profileImage ? (
                        <img src={user.profileImage} alt="프로필" />
                    ) : (
                        <div className="default-avatar">👤</div>
                    )}
                </div>
                <div className="profile-info">
                    <h2 className="user-name">{user.nickname}</h2>
                    <p className="user-email">{user.email}</p>
                    <span 
                        className="couple-status"
                        style={{
                            backgroundColor: getCoupleStatusColor(user.coupleStatus),
                            color: 'white'
                        }}
                    >
                        {getCoupleStatusText(user.coupleStatus)}
                    </span>
                </div>
            </div>

            
        </div>
    );
};

export default UserProfile;
